import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as interFace from "../../Config/interface.config";
import * as PATH from "../../API/path";
import APIRequest from "../../API";
import { normalizeCreatorUsername } from "../../Utils";

const initialState: Partial<interFace.UserDetails> = {
  loading: false,
};

// Get user details by username for viewing a profile. Both /username and
// /@username remain supported; only the normalized value reaches the API.
export const getUserDetailsByUsername = createAsyncThunk(
  "/user/username/details",
  async (
    { username, page, limit = 10 }: { username: string; page: number; limit?: number },
    { rejectWithValue }
  ) => {
    try {
      const normalizedUsername = normalizeCreatorUsername(username);
      if (!normalizedUsername) {
        return rejectWithValue({ message: "Invalid creator username" });
      }

      const path = { ...PATH.get_user_by_username };
      path.url = path.url.replace("{{username}}", encodeURIComponent(normalizedUsername));

      const response: any = await APIRequest(path, null, { page, limit });

      if (response.error) {
        return rejectWithValue(response.error);
      }

      const { data } = response;
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const viewedProfileSlice = createSlice({
  name: "viewedProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserDetailsByUsername.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      getUserDetailsByUsername.fulfilled,
      (state, { payload }) => {
        Object.assign(state, payload);
        state.loading = false;
      }
    );

    builder.addCase(getUserDetailsByUsername.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default viewedProfileSlice.reducer;
